export default {
    title: '個資保護條款'
}
